import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { Taxon } from 'src/app/domain/Analyse/taxon';
import { WaterProcess } from 'src/app/domain/EAU/water-process';
import { IBDProcess } from 'src/app/domain/IBD/IDB-process';
import { IBGNProcess } from 'src/app/domain/IBGN/IBGN-process';
import { IBMRProcess } from 'src/app/domain/IBMR/IBMR-process';
import { IMLProcess } from 'src/app/domain/IML/IML-process';
import { LacProcess } from 'src/app/domain/Lac - EAU/lac-process';
import { MGCEProcess } from 'src/app/domain/MGCE/MGCE-Process';
import { Process } from 'src/app/domain/MPCE/process';
import { Document } from 'src/app/domain/Shared/document';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { Intervention } from 'src/app/domain/planning/intervention';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { SampleTakingModel } from 'src/app/models/new-substrat-model';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { SANDREService } from 'src/app/services/SANDRE-service';
import { AnalyseService } from 'src/app/services/analyse-service';
import { DocumentService } from 'src/app/services/document.service';
import { EnvironmentService } from 'src/app/services/environment-service';
import { IBDService } from 'src/app/services/ibd.service';
import { IBGNService } from 'src/app/services/ibgn.service';
import { IBMRService } from 'src/app/services/ibmr.service';
import { IMLService } from 'src/app/services/iml-service';
import { InterventionService } from 'src/app/services/intervention.services';
import { LacService } from 'src/app/services/lac.service';
import { MasterSondeService } from 'src/app/services/master-sonde.service';
import { MGCEService } from 'src/app/services/mgce.service';
import { MPCEService } from 'src/app/services/mpce-service';
import { UserService } from 'src/app/services/user-service';
import { WaterService } from 'src/app/services/water.service';
import { CoreData } from 'src/app/tools/core-data';
import { LoadingTask } from 'src/app/tools/loading-task';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';
import { InterventionCreationBoxComponent } from 'src/app/tools/ui/intervention-creation-box/intervention-creation-box.component';
import { EDocumentType } from 'src/app/tools/ui/mutilple-file-upload-box/document-type';
import { MultipleFileUploadBoxDialog } from 'src/app/tools/ui/mutilple-file-upload-box/multiple-file-upload-box';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { db } from '../../db/db';
import { SampleCodeBoxComponent } from 'src/app/tools/ui/cyano-creation-box/sample-code-box.component';
declare var require: any;
const { version: appVersion } = require('../../../../package.json');
let ng: InterventionListComponent;

@Component({
    selector: 'app-intervention-list',
    templateUrl: './intervention-list.component.html',
    styleUrls: ['./intervention-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InterventionListComponent implements OnInit {
    public IsOffline: boolean;
    AppVersion: string;
    public InterventionList: Intervention[] = [];
    public FilteredInterventionList: Intervention[] = [];
    SearchText: string = ''
    Date?: Date;

    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 1,
                Text: undefined,
                Icon: 'publish'
            },
            {
                Id: 2,
                Text: undefined,
                Icon: 'add'
            },
            {
                Id: 4,
                Text: undefined,
                Icon: 'power_off'
            },
            {
                Id: 5,
                Text: undefined,
                Icon: 'build'
            }
        ];

    constructor(
        public coreData: CoreData,
        private interventionService: InterventionService,
        private environmentService: EnvironmentService,
        private mpceService: MPCEService,
        private ibgnService: IBGNService,
        private ibdService: IBDService,
        private waterService: WaterService,
        private mgceService: MGCEService,
        private ibmrService: IBMRService,
        private imlService: IMLService,
        private analyseService: AnalyseService,
        private sandreService: SANDREService,
        private userService: UserService,
        private lacService: LacService,
        private documentService: DocumentService,
        private masterSondeService: MasterSondeService,
        // Indexed DB services
        // @Todo Create one db proxy

        // --------------------------------------------------------
        public datepipe: DatePipe,
        private router: Router,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        public loadingTask: LoadingTask) { }

    ngOnInit() {
        ng = this;
        this.AppVersion = appVersion;
        this.IsOffline = this.coreData.IsOffline;
        if (this.IsOffline) {
            this.getInterventionList();
        } else {
            this.getAllIntervention();
        }

        this.coreData.CurrentPageName = "";
        this.coreData.CurrentIntervention = undefined
    }

    clearFilter() {
        this.SearchText = ''
        this.Date = undefined
        this.FilteredInterventionList = this.InterventionList
    }

    search() {

        this.FilteredInterventionList = this.InterventionList
            // .filter(x => )
            .filter(x => x.Code && ((this.Date && this.sameDay(x.Date, this.Date)) || (this.SearchText !== '' && x.ELIMSData.ClientName.toLowerCase().includes(this.SearchText.toLowerCase()))))

    }

    getBackgroundColorByInterventionStatus(type: EInterventionType) {
        switch (type) {
            case EInterventionType.IBD:
                return '#F5822B !important';
            case EInterventionType.IBGN:
                return '#FFDD4A !important';
            case EInterventionType.MPCE:
                return '#3AB795 !important';
            case EInterventionType.EAU:
                return 'aqua !important';
            case EInterventionType.LAC:
                return 'cornflowerblue !important';
            case EInterventionType.IBMR:
                return 'olivedrab !important';
            case EInterventionType.MGCE:
                return 'navy !important';
            case EInterventionType.IML:
                return '#bda676 !important';
        }
    }

    getTextColorByInterventionStatus(type: EInterventionType) {
        switch (type) {
            case EInterventionType.IBD:
            case EInterventionType.IBGN:
            case EInterventionType.MPCE:
            case EInterventionType.EAU:
            case EInterventionType.LAC:
            case EInterventionType.IBMR:
            case EInterventionType.IML:
                return 'black !important';
            case EInterventionType.MGCE:
                return 'white !important';
        }
    }

    getInterventionList() {
        forkJoin([
            this.userService.getAll(),
            this.masterSondeService.getActiveSonde(),
        ]).subscribe(async ([A, B]) => {
            await db.resetUserList();
            for (const user of A) {
                await db.addUser(user);
            }
            await db.resetSondeList();
            for (const sonde of B) {
                await db.addSonde(sonde);
            }
        })

        this.interventionService.getInterventionBySampler().subscribe(x => {
            if (x === null) {
                if (this.coreData.getLocalInterventionList().length > 0) {
                    this.coreData.getLocalInterventionList().forEach(i => {
                        this.InterventionList.push(this.coreData.getOfflineIntervention(i));
                        this.FilteredInterventionList.push(this.coreData.getOfflineIntervention(i));
                    });
                }
            } else {
                this.FilteredInterventionList = this.InterventionList = x;
                _.intersection(this.coreData.getLocalInterventionList(), this.InterventionList.map(i => i.Code)).forEach(y => {
                    this.InterventionList[this.InterventionList.findIndex(z => z.Code === y)] = this.coreData.getOfflineIntervention(y);
                });

                this.doCardListAdjustmentAlignCardOnTheLeft();
            }
        });
    }

    getAllIntervention() {
        this.interventionService.getAllActiveIntervention().subscribe(x => {
            this.FilteredInterventionList = this.InterventionList = x;
            this.doCardListAdjustmentAlignCardOnTheLeft();
        });
    }

    // addNewIntervention(type: EInterventionType) {
    //     this.interventionService.createIntervention(type).subscribe((x: string) => {
    //         _.remove(this.InterventionList, int => int.Code === undefined || int.Code === '');
    //         const i = new Intervention();
    //         i.Type = type;
    //         i.Code = x;
    //         this.InterventionList.push(i);

    //         this.doCardListAdjustmentAlignCardOnTheLeft();
    //     });
    // }

    getInterventionLabel(int: Intervention) {
        return StringConverter.getInterventionTypeName(int.Type)
    }

    doCardListAdjustmentAlignCardOnTheLeft() {

        if (this.IsOffline) {
            return;
        }

        if (!this.InterventionList) {
            return;
        }
        const fakeCards = 5 - (this.InterventionList.length % 5);
        for (let i = 0; i < fakeCards; i++) {
            this.InterventionList.push(new Intervention());
        }
    }

    dispatch(event: SpeedDialFabModel) {
        if (event.Id === 1) {
            this.openMultipleUploadDialog();
        }
        else if (event.Id === 2) {
            const dialogRef = this.dialog.open(InterventionCreationBoxComponent, {
                data: {},
                width: '777px',
                disableClose: true
            });

            dialogRef.afterClosed().subscribe((result: Intervention) => {
                if (result) {
                    this.getAllIntervention()
                }
            });

        } else if (event.Id === 4) {
            const m: ConfirmBoxModel = new ConfirmBoxModel();
            m.QuestionTitle = 'Êtes vous sûrs sur de vouloir vous déconnecter, les données non synchronisées seront perdues ?';
            m.WithReason = false;
            const dialogRef = this.dialog.open(ConfirmBoxDialog, {
                data: m,
                width: '777px',
                disableClose: true
            });

            dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
                if (result) {
                    this.logoff();
                }
            });
        }
        else if (event.Id === 5) {
            this.exportDB();
        }
    }

    async exportDB() {

        db.exportDB(function (err, jsonString) {
            if (err) {
                console.error(err);
            } else {
                ng.interventionService.exportIndexedDBAndLocalStorageAsJSON(jsonString, JSON.stringify(localStorage)).subscribe(x => {
                    if (x) {
                        NotificationManager.handleSuccess('Données correctement transférées vers le serveur pour investigation !', ng.snackBar);
                    }
                })
            }
        })

    }

    logoff() {
        this.coreData.getLocalInterventionList().forEach(x => {

            this.coreData.clearLocalIntervention(x, this.coreData.getOfflineIntervention(x).ProcessCode);
            this.coreData.removeFromLocalList(x);
        });
        this.coreData.clearToken();
    }

    navigateToIntervention(intervention: Intervention) {
        if (intervention.Code === undefined || intervention.Code === '' || this.loadingTask.IsLoading) {
            return;
        }
        this.coreData.CurrentPageName = intervention.SampleCode;
        if (this.coreData.IsOffline && !this.coreData.getOfflineIntervention(intervention.Code)) {
            NotificationManager.handleWarning('Veuillez recupérer l\'intervention afin de pouvoir y accéder', this.snackBar);
            return;
        }

        this.coreData.CurrentIntervention = intervention;
        this.router.navigate([ENavigationRoute.InterventionDashboard, { type: intervention.Type, interventionCode: intervention.Code }]);
    }

    navigateToAnalysisList() {
        this.router.navigate([ENavigationRoute.AnalyseList, {}]);
    }

    openMultipleUploadDialog() {

        const dialogRef = this.dialog.open(MultipleFileUploadBoxDialog, {
            data: { code: undefined, type: EDocumentType.ImportInterventions, isForImport: true },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                NotificationManager.handleSuccess('Interventions correctement importées !', this.snackBar);
            }
        });
    }

    openSampleCodeBox(intervention: Intervention) {
        const dialogRef = this.dialog.open(SampleCodeBoxComponent, {
            data: 'Ajout d\'un Sample Code a l\'intervention',
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.interventionService.updateZombiesToRedemption(intervention.Code, result).subscribe(x => {
                    if (x) {
                        this.getAllIntervention()
                        NotificationManager.handleSuccess('Sample Code correctement ajouté !', this.snackBar);
                    }
                })
            }
        });
    }

    cancelIntervention(intervention: Intervention) {
        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Êtes vous sûrs sur de vouloir annuler ?';
        m.WithReason = true;
        m.WithLengthValidation = true;
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
            if (result) {
                this.interventionService.cancel(intervention, result.Reason).subscribe(x => {
                    if (x) {
                        NotificationManager.handleSuccess('Intervention annulée', this.snackBar);
                        _.remove(this.InterventionList, intervention);
                    }
                });
            }
        });
    }

    // @TODO Message de confirmation warmup OK - Tout dans le fork
    async warmup(intervention: Intervention) {
        if (intervention.Code === undefined || intervention.Code === '') {
            return;
        }

        let succeededToBeStored: boolean[] = [];
        this.loadingTask.activateLoading();

        await this.interventionService.startEndLocalStorageOperation(intervention.Code).toPromise();

        await this.refreshAfterSyncing(intervention.Code, intervention.ProcessCode);
        forkJoin([
            this.interventionService.getInterventionDetails(intervention.Code),
            this.environmentService.getEnvironment(intervention.Code),
            this.documentService.getAllDocumentByFilter(intervention.Code),
            this.userService.getAll(),
            this.masterSondeService.getActiveSonde(),
        ]).subscribe(async ([A, B, C, D, E]) => {

            if (!A || !B || !C || !D || !E) {
                return;
            }

            await db.addIntervention(A);
            succeededToBeStored.push(this.coreData.setOfflineIntervention(A));
            succeededToBeStored.push(this.coreData.setOfflineInterventionDescription(A.Code, B));

            if (!_.includes(succeededToBeStored, false)) {
                switch (intervention.Type) {
                    case EInterventionType.MPCE:
                        await this.mpceService.getGroupement(A.ProcessCode).toPromise().then((x: boolean) => {
                            A.GroupementPrelevement = x;
                        });
                        await this.mpceService.getStation(A.ProcessCode).toPromise().then(async x => {
                            await this.mpceService.getSubstrat(A.ProcessCode).toPromise().then(y => {
                                x.Substrats = y;
                                succeededToBeStored.push(this.coreData.setOfflineProcess(x));
                                succeededToBeStored.push(this.coreData.setOfflineProcessSubstratList(A.ProcessCode, y));
                            });
                        });
                        break;
                    case EInterventionType.IBGN:
                        await this.ibgnService.getStation(A.ProcessCode).toPromise().then(async x => {
                            await this.ibgnService.getSubstrat(A.ProcessCode).toPromise().then(y => {
                                x.Substrats = y;
                                succeededToBeStored.push(this.coreData.setOfflineProcess(x));
                                succeededToBeStored.push(this.coreData.setOfflineProcessSubstratList(A.ProcessCode, y));
                            });
                        });
                        break;
                    case EInterventionType.IBD:
                        await this.ibdService.getProcessByCode(A.ProcessCode).toPromise().then(x => {
                            succeededToBeStored.push(this.coreData.setOfflineProcess(x));
                        });
                        break;
                    case EInterventionType.EAU:
                        await this.waterService.getProcessByCode(A.ProcessCode).toPromise().then(x => {
                            succeededToBeStored.push(this.coreData.setOfflineProcess(x));
                        });
                        break;
                    case EInterventionType.LAC:
                        await this.lacService.getLacProcessByCode(A.ProcessCode).toPromise().then(x => {
                            succeededToBeStored.push(this.coreData.setOfflineProcess(x));
                        });
                        break;
                    case EInterventionType.IBMR:
                        await this.ibmrService.getProcessByCode(A.ProcessCode).toPromise().then(x => {
                            succeededToBeStored.push(this.coreData.setOfflineProcess(x));
                        });
                        await this.sandreService.getIBMRTaxonList().toPromise().then(async x => {
                            await db.resetTaxonList(x);
                        });
                        await this.analyseService.getAnalyseByIntervention(intervention.Code).toPromise().then(x => {
                            this.coreData.pushToAnalyseLocalList(intervention.Code);
                            this.coreData.setOfflineAnalyse(intervention.Code, x);
                        });
                        break;
                    case EInterventionType.MGCE:
                        await this.mgceService.getProcessByCode(A.ProcessCode).toPromise().then(x => {
                            succeededToBeStored.push(this.coreData.setOfflineProcess(x));
                        });
                        break;
                    case EInterventionType.IML:
                        await this.imlService.getIMLProcessByCode(A.ProcessCode).toPromise().then(x => {
                            succeededToBeStored.push(this.coreData.setOfflineProcess(x));
                        });
                        break;
                }

                // Cannot use await inside a forEach...
                for (const d of C.Documents?.filter(y => (y.DocumentType >= 1 && y.DocumentType <= 6) || y.DocumentType === 13)) {
                    await db.attachPictureToIntervention(await db.getInterventionByCode(A.Code), d);
                }

                await db.resetUserList();
                for (const user of D) {
                    await db.addUser(user);
                }
                await db.resetSondeList();
                for (const sonde of E) {
                    await db.addSonde(sonde);
                }
            }

            if (!_.includes(succeededToBeStored, false)) { // Do we have everything locally ?
                this.coreData.pushToLocalList(A.Code);
            } else { // Not Fully retrieved so we need to clean partial data
                NotificationManager.handleError('Echec de la récupération des données !', this.snackBar);
                // if (this.coreData.getOfflineIntervention(A.Code)) {
                //     this.coreData.clearLocalIntervention(A.Code, this.coreData.getOfflineIntervention(A.Code).ProcessCode);
                //     this.coreData.removeFromLocalList(A.Code);
                // }
                this.refreshAfterSyncing(A.Code, A.ProcessCode);
            }

            await this.interventionService.startEndLocalStorageOperation(intervention.Code, false).toPromise();
            this.loadingTask.deactivateLoading();
        });

    }

    hasLocalData(int: Intervention) {
        if (this.coreData.getLocalInterventionList().includes(int.Code)) {
            return true;
        }
        return false;
    }

    openConfirmDialog(int: Intervention) {
        if (int.Code === undefined || int.Code === '') {
            return;
        }

        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Êtes vous sûrs sur de vouloir remettre cette intervention en cache, les données préalablement entrées seront perdues ?';
        m.WithReason = false;
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
            if (result) {
                // this.coreData.removeFromLocalList(int.Code);
                // this.coreData.clearLocalIntervention(int.Code, int.ProcessCode);
                this.warmup(int);
            }
        });
    }

    openSamplingDateConfirmDialog() {
        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'La date de prélèvement indiquée sur la station est différente de la date du jour. Voulez-vous quand même synchroniser cette intervention ?';
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        return dialogRef.afterClosed().pipe(map(x => { if (x) { return true; } })).toPromise();
    }

    private sameDay(d1: Date, d2: Date) {
        return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }

    async sync(int: Intervention) {
        if (int.Code === undefined || int.Code === '') {
            return;
        }

        if (!this.coreData.getOfflineInterventionDescription(int.Code).Code) {
            NotificationManager.handleWarning('Veuillez remplir les details de l\'intervention', this.snackBar);
            return;
        }

        const plannedSamplingDate = new Date(int.Date);
        // plannedSamplingDate.setHours(0, 0, 0, 0);
        if (!this.sameDay(new Date(), plannedSamplingDate)) { // Date defer from the planned date so let's verify user is ok with that
            const willForce = await this.openSamplingDateConfirmDialog();
            if (!willForce) {
                return;
            }
        }

        NotificationManager.handleSuccess('Synchronisation: starting !', this.snackBar);

        const documents: Document[] = [];
        const list: SampleTakingModel[] = [];
        let taxonList: Taxon[] = [];
        let process: IBGNProcess | Process | IBDProcess | WaterProcess | LacProcess | IBMRProcess | MGCEProcess | IMLProcess;
        switch (int.Type) {
            case EInterventionType.MPCE:
                process = this.coreData.getOfflineProcess(int.ProcessCode) as Process;
                this.coreData.getOfflineProcessSubstratList(int.ProcessCode)?.forEach(element => {
                    if (element.Type) {
                        element.Type = element.Type;
                    }
                    list.push(element as SampleTakingModel);
                });
                break;
            case EInterventionType.IBGN:
                process = this.coreData.getOfflineProcess(int.ProcessCode) as IBGNProcess;
                this.coreData.getOfflineProcessSubstratList(int.ProcessCode)?.forEach(element => {
                    if (element.Type) {
                        element.Type = element.Type;
                    }

                    list.push(element as SampleTakingModel);
                });
                break;
            case EInterventionType.IBD:
                process = this.coreData.getOfflineProcess(int.ProcessCode) as IBDProcess;
                break;
            case EInterventionType.EAU:
                process = this.coreData.getOfflineProcess(int.ProcessCode) as WaterProcess;
                break;
            case EInterventionType.LAC:
                process = this.coreData.getOfflineProcess(int.ProcessCode) as LacProcess;
                break;
            case EInterventionType.IBMR:
                process = this.coreData.getOfflineProcess(int.ProcessCode) as IBMRProcess;
                // taxonList = this.coreData.getOfflineAnalyse(int.Code)?.TaxonList;
                break;
            case EInterventionType.MGCE:
                process = this.coreData.getOfflineProcess(int.ProcessCode) as MGCEProcess;
                break;
            case EInterventionType.IML:
                process = this.coreData.getOfflineProcess(int.ProcessCode) as IMLProcess;
                break;
        }

        NotificationManager.handleSuccess('Synchronisation: intervention loaded !', this.snackBar);

        const plist = await db.getPictureList(await db.getInterventionByCode(int.Code));
        if (plist) {
            documents.push(...plist);
        }

        NotificationManager.handleSuccess('Synchronisation: images loaded and beginning transfer !', this.snackBar);

        this.interventionService.updateOfflineIntervention(
            this.coreData.getOfflineIntervention(int.Code),
            this.coreData.getOfflineInterventionDescription(int.Code),
            process,
            list,
            documents,
        ).subscribe(x => {
            if (x) {
                this.refreshAfterSyncing(int.Code, int.ProcessCode);

                NotificationManager.handleSuccess('Synchronisation réussie !', this.snackBar);
                this.getInterventionList();
            }
        });
    }

    async refreshAfterSyncing(interventionCode: string, processCode: string) {

        await db.deleteAllPicturesForAnIntervention(await db.getInterventionByCode(interventionCode))
        await db.deleteIntervention(interventionCode);

        this.coreData.clearLocalIntervention(interventionCode, processCode);
        this.coreData.removeFromLocalList(interventionCode);
        this.coreData.removeFromAnalyseLocalList(interventionCode);

    }
}
